import { Skeleton, SkeletonAvatar, SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

export const PaymentsListSectionLoader = () => {
  return (
    <div className="h-[500px]">
      <div className="mb-16 flex items-center gap-16">
        <SkeletonAvatar variant="square" />
        <div className="flex flex-col gap-8">
          <SkeletonText width="310px" />
          <Skeleton height="var(--grapes-unit-8)" width="61px" />
        </div>
      </div>
      {Array.from({ length: 5 }, (_, key) => (
        <div
          className="flex items-center justify-between border-0 border-b border-solid border-border-default py-16"
          key={key}
        >
          <div className="flex items-center gap-16">
            <SkeletonAvatar />
            <div className="flex flex-col gap-8">
              <SkeletonText width="100px" />
              <Skeleton height="var(--grapes-unit-8)" width="61px" />
            </div>
          </div>
          <SkeletonText width="75px" />
          <SkeletonText width="58px" />
          <SkeletonText width="98px" />
        </div>
      ))}
    </div>
  );
};
